export const LOGOTIPO_TITLE = 'Logotipo';
export const CONTATOS_ATENDIMENTO_TITLE = 'Contatos para Atendimento';
export const COMISSAO_PRESTACAO_CONTAS_TITLE = 'Comissão para Prestação de Contas';
export const PRAZO_EXPIRACAO_ACESSO_TITLE = 'Prazo de Expiração para Acesso';
export const EMAIL_FIELD = 'E-mail';
export const TELEFONE_1_FIELD = 'Telefone 1';
export const TELEFONE_2_FIELD = 'Telefone 2';
export const CLIENTES_EXCLUSIVOS_FIELD_COMISSAO_PRESTACAO_CONTAS = ' Clientes exclusivos';
export const CLIENTES_EXCLUSIVOS_PRAZO_EXPIRACAO_ACESSO_FIELD = ' Clientes exclusivos (dias úteis)*';
export const CLIENTES_ABE_FIELD = ' Clientes ABE  (dias úteis)*';
export const CONFIGURACOES_GERAIS_TITLE = 'Configurações Gerais';
export const VALOR_MAXIMO_ACORDO_SEGURO_FIELD = 'Valor máximo Acordo Seguro';
export const FASE_FIELD = 'Fase que receberá processos com acordo';
export const PASTA_FIELD = 'Pasta';

// Taxas e Descontos
export const TAXAS_DESCONTOS_TITLE = 'Taxas e Descontos';
export const DESCONTO_PIX_TITLE = 'Desconto para o Pix';
export const OPCAO_PAGAMENTO_FIELD = 'Opção de pagamento';
export const DESCONTO_FIELD = 'Desconto';
